import { createFileRoute } from '@tanstack/react-router'
import { Outlet } from '@/libs/router'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/tasks')({
	component: TasksLayout,
})

function TasksLayout() {
	return (
		<PageLayout data-id='tasks-page'>
			<Outlet />
		</PageLayout>
	)
}
